export const getContactUsWithElectricalProductSupportConfig = () => ({
  type: "custom",
  templateName: "Contact us decision tree node",
  diagnosticResponses: [
    {
      id: "deliveryQueries",
      responseText: "Delivery queries",
    },
    {
      id: "returnsAndRefunds",
      responseText: "Returns & refunds",
    },
    {
      id: "electricalProductSupport",
      responseText: "Electrical product support",
      url: `${process.env.NEXT_PUBLIC_TV_AND_LAPTOP_SUPPORT_URL}?origin=Web&referrer=ContactUs`,
      openInNewTab: false,
    },
    {
      id: "problemsWithProduct",
      responseText: "Product problems & guarantees",
    },
    {
      id: "productStockInformation",
      responseText: "Product & stock",
    },
    {
      id: "placeEditCancelOrder",
      responseText: "Place, change or cancel order",
    },
    {
      id: "myJLMembership",
      responseText: "My John Lewis membership",
    },
    {
      id: "myAccountOnline",
      responseText: "My account online",
    },
  ],
  diagnosticResponsesHaveIcons: true,
  fields: [],
  id: "contact-us",
  question: "To direct you to the best contact, please choose one of the options below",
  title: null,
});
